<template>
  <v-app>
    <the-navigation-drawer
      v-if="isLoggedIn"
      :open="navDrawer"
      @drawerChange="navDrawer = $event"
    />

    <the-app-bar v-if="isLoggedIn" @drawerOpen="navDrawer = true" />

    <v-main class="main-content">
      <router-view />
    </v-main>

    <v-footer
      v-if="isLoggedIn"
      app
      inset
      :color="$vuetify.theme.dark ? 'grey darken-4' : 'white'"
      height="80"
      class="justify-center elevation-1"
    >
      <v-img
        src="/assets/logo-klidi.png"
        contain
        max-width="130"
        class="mr-4"
        :style="{
          filter: $vuetify.theme.dark ? 'invert(0.85) brightness(0.9)' : 'none'
        }"
      />
      <v-img
        src="/assets/EKT-ESPA.png"
        contain
        max-width="400"
        :style="{
          filter: $vuetify.theme.dark ? 'invert(0.85) brightness(0.9)' : 'none'
        }"
      />
    </v-footer>

    <the-snackbar />
  </v-app>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import TheNavigationDrawer from './components/TheNavigationDrawer.vue'
import TheAppBar from './components/TheAppBar.vue'
import TheSnackbar from './components/TheSnackbar.vue'

export default {
  components: {
    TheNavigationDrawer,
    TheAppBar,
    TheSnackbar
  },
  data() {
    return {
      navDrawer: false
    }
  },
  // created() {
  //   console.log('ooooooooooooooo')
  //   console.log(this.$route)
  //   const jwtToken = this.$route.query.token
  //   if (jwtToken) {
  //     this.SET_ACCESS_TOKEN(jwtToken)
  //   }
  // },
  methods: {
    ...mapMutations(['SET_ACCESS_TOKEN'])
  },
  computed: {
    ...mapGetters(['isLoggedIn'])
  }
}
</script>

<style lang="scss">
html,
body {
  height: 100%;
  margin: 0;
  padding: 0;
}

.v-application {
  transition: background-color 0.3s ease !important;
  min-height: 100vh;
}

.theme--light.v-application {
  background-color: #f1f1f1 !important;
}

.theme--dark.v-application {
  background-color: #303030 !important;
}

.v-application--wrap {
  min-height: 100vh !important;
  background-color: inherit !important;
}

.v-main {
  padding-bottom: 80px !important;
}

.v-main__wrap {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background: inherit;
}

.theme--light .v-main__wrap {
  background: #f1f1f1 !important;
}

.theme--dark .v-main__wrap {
  background: #303030 !important;
}

// Fill entire viewport with dark background
body.theme--dark {
  background-color: #303030 !important;
}

.main-content {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
}

.footer-wrapper {
  border-top: 1px solid rgba(0, 0, 0, 0.12);
  z-index: 4;
}

.theme--dark .footer-wrapper {
  border-top-color: rgba(255, 255, 255, 0.12);
  background-color: #424242 !important;
}

.wrapper {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.flex-1 {
  flex: 1 1 auto;
}

.scrollable {
  overflow-y: auto;
}

.clickable {
  cursor: pointer;
}

.h-80 {
  height: 80%;
}

.h-90 {
  height: 90%;
}

.h-95 {
  height: 95%;
}

.h-100 {
  height: 100%;
}

.link {
  cursor: pointer;
  text-decoration: none;
  color: var(--v-primary-base);
  transition: all 0.2s;

  &:hover {
    text-decoration: underline;
    color: var(--v-primary-lighten1);
  }
}

.cut-text {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

// css overriding
::-webkit-scrollbar-track {
  background: #eeeeee;
  border-radius: 10px;
}

::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-thumb {
  background: #a0a0a0;
  border-radius: 5px;
}

::-webkit-scrollbar-thumb:hover {
  background: #787878;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

* {
  margin: 0;
}

html,
body {
  height: 100%;
}

body {
  line-height: 1.5;
  -webkit-font-smoothing: antialiased;
}

img,
picture,
video,
canvas,
svg {
  display: block;
  max-width: 100%;
}

input,
button,
textarea,
select {
  font: inherit;
}

p,
h1,
h2,
h3,
h4,
h5,
h6 {
  overflow-wrap: break-word;
}

#root,
#__next {
  isolation: isolate;
}

/* Dark Mode Transition */
.v-card,
.v-sheet,
.v-app-bar,
.v-data-table,
.v-list,
.v-footer {
  transition:
    background-color 0.3s ease,
    color 0.3s ease !important;
}

/* Dark mode specific styles */
.theme--dark {
  .v-data-table {
    background-color: #1e1e1e !important;
  }

  .v-data-table__wrapper {
    background-color: transparent !important;
  }

  .statistics-card {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3) !important;
  }

  // Fix text visibility in dark mode
  .text-caption,
  .text-body-2,
  .text-body-1,
  .text-h6,
  .text-h5,
  .text-h4,
  .text-h3 {
    color: inherit !important;
  }
}
</style>
